module.exports = __webpack_public_path__ + "media/images/game/bonus_tasks/pracovni_listy-852bf7a0c2e0da55eb0d52e2435b3d34.png";